import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import PosEarlyUnblockFilter from "../Filters/PosEarlyUnblockFilter";
import { ColumnHelper } from "util/TableHelper";
import { useHistory } from "react-router-dom";

import { Table, Empty, Col, Row, Tooltip, message, Button, Modal } from "antd";
import { BarsOutlined, FileExcelOutlined, RollbackOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const PosEarlyUnblock = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const history = useHistory();

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const [tableRolesTenantParameter, setTableRolesTenantParameter] = useState({});

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/PosEarlyUnblock?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
    ).then((response) => {

      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

 
  const renderDetailButton = (bankId, earlyUnblockId) => (
    <Link to={`/pos-transaction/${bankId}&${earlyUnblockId}&true`} >
      <MenuUnfoldOutlined style={{ fontSize: "130%" }} />
    </Link>
  )


  const tableColumns = [
    {
      title: "POS Banka",
      dataIndex: "bankLogo",
      width: "120px",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Bloke Kaldırma Tarihi",
      dataIndex: "unblockDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY")
    },
    {
      title: "İşlem Adedi",
      dataIndex: "numberOfTransactions",
    },
    {
      title: "Toplam Net Tutar",
      dataIndex: "totalAmount",
      render: ColumnHelper.renderDecimal,
      align:"right"
    },
    {
      title: "Banka ile Anlaşılan Tutar",
      dataIndex: "paidAmount",
      render: ColumnHelper.renderDecimal,
      align:"right"
    },
    {
      title: "Fark",
      dataIndex: "differenceAmount",
      render: ColumnHelper.renderDecimal,
      align:"right"
    },
    {
      title: "Detay",
      dataIndex: "bankId",
      width: "1%",
      align: "center",
      render: (data, row) => renderDetailButton(data, row.id)
    },
  ];

  return (
    <>
      {props.match.params.filter && (
        <Row style={{ marginBottom: 9 }}>
          <Col flex={1}>
            <a
              onClick={() => history.goBack()}
              style={{ color: "black", marginLeft: "4%" }}
            >
              {" "}
              <RollbackOutlined /> GERİ DÖN
            </a>
          </Col>
          <Col flex={4}></Col>
        </Row>
      )}

      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS ERKEN BLOKE ÇÖZÜM RAPORU
          </p>
        </Col>
       
      </Row>


      <PosEarlyUnblockFilter
        filter={props.match.params.filter}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={tableColumns.filter((column) => !column.isRowDetail)}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default PosEarlyUnblock;
